import React from 'react';

interface LevelBadgeProps {
  level: number;
  size?: 'sm' | 'md';
}

export const LevelBadge: React.FC<LevelBadgeProps> = ({ level, size = 'sm' }) => {
  const dimension = size === 'sm' ? 18 : 28;
  const fontSize = size === 'sm' ? '0.65rem' : '0.8rem';

  return (
    <span
      title={`Level ${level}`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: dimension,
        height: dimension,
        borderRadius: '50%',
        backgroundColor: '#ffebcc',
        color: '#000',
        fontSize,
        fontWeight: 700,
        lineHeight: 1,
        flexShrink: 0,
      }}
    >
      {level}
    </span>
  );
};
